// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1uh9j","subheader":"ReorderModal_subheader__m9JMP","listWrap":"ReorderModal_listWrap__3LJmD"};